export default __webpack_public_path__ + "static/media/Lock-large.db811a2e.svg";